import { useMemo } from "react";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

import type { CreateOrderResultUI } from "../../../model/order.model";

export const useOrderResultDialog = (result: CreateOrderResultUI | null) => {
  const createdList = useMemo(() => result?.created ?? [], [result]);

  const failedList = useMemo(
    () =>
      (result?.failed ?? []).map((f) => ({
        ...f,
        errorMessage: f.message ?? "Não foi possível criar este item.",
        status: "ERRO",
      })),
    [result]
  );

  const header = useMemo(() => {
    if (!result) return null;
    const icons = {
      SUCESSO: {
        title: "Sucesso!",
        color: "success.main",
        icon: CheckCircleOutlineIcon,
      },
      PARCIAL: {
        title: "Sucesso parcial",
        color: "warning.main",
        icon: WarningAmberIcon,
      },
      ERRO: {
        title: "Erro no pedido",
        color: "error.main",
        icon: ErrorOutlineIcon,
      },
    };
    const config = icons[result.overall ?? "ERRO"] || icons.ERRO;
    return {
      ...config,
      subtitle:
        result.overall === "SUCESSO"
          ? "Efetuado com sucesso!"
          : "Verifique os detalhes abaixo.",
    };
  }, [result]);

  return { createdList, failedList, header, open: Boolean(result) };
};
